import PropTypes from 'prop-types';

import {v4 as uuidv4} from 'uuid';

import {Circle, FabricImage, Group} from 'fabric';

import {isCustom, limitReached, setLastObjectActive} from '../canvas-helper';

import {
    createPlayerName,
    createPlayerNumber,
    getCircleSizeOptions,
    getNextPlayerNumber
} from './player-utils';

const PlayerCircle = ({canvas, colors, size}) => {

    canvas.on({
        'mouse:down': (o) => {
            if (limitReached(canvas)) {
                return;
            }

            if (canvas.getActiveObject()) {
                if (isCustom(canvas.getActiveObject())) {
                    return;
                }

                canvas.discardActiveObject();
            }

            const pointer = canvas.getScenePoint(o.e);
            const nextNumber = getNextPlayerNumber(canvas, colors.name).toString();
            createPlayerCircle(
                canvas,
                colors,
                size,
                pointer.x,
                pointer.y,
                nextNumber,
                null, // no image
                {},
                (canvas, group) => {
                    canvas.add(group);
                    setLastObjectActive(canvas);
                }
            );
        },
    });
};

export const createPlayerCircle = (
    canvas,
    colors,
    size,
    posX,
    posY,
    playerNumber,
    playerImage,
    customData,
    onComplete,
    playerName = ''
) => {
    const sizeValue = getCircleSizeOptions(size);
    
    const circle = new Circle({
        strokeWidth: 3,
        fill: colors.value1,
        stroke: colors.value2,
        //radius: 20,
        radius: sizeValue.size,
        originX: 'center',
        originY: 'center',
        left: 0,
        top: 0,
        hasBorders: false,
        hasControls: false,
    });

    const avatarCrop = '?w=100&h=100&m=crop';
    if (playerImage ) {
        FabricImage.fromURL(playerImage.url + avatarCrop).then((imageCircle) => {
            imageCircle.clipPath = circle;
            imageCircle.originX = 'center';
            imageCircle.originY = 'center';
            imageCircle.custom = {type: 'player-image', id: uuidv4()};
            
            // imageCircle.set({
            //     stroke : 'green',
            // });
            // imageCircle.scaleToHeight(80);
            // imageCircle.scaleToWidth(80);
            // let textColor = '#000000';
            // textColor = getCircleTextColor(fill,textColor);
            
            const textSize = 28 + size;
            const number = createPlayerNumber(
                playerNumber.toString(),
                colors.textColor,
                textSize
            );
            
            const border = new Circle({
                strokeWidth: 4,
                fill: 'rgba(0,0,0,0)',
                stroke: colors.value2,
                radius: sizeValue.size + 6,
                hasBorders: false,
                hasControls: false,
                originX: 'center',
                originY: 'center',
            });

            // adjust number
            // number.top = ((border.height / 2) + 2) * -1;
            // number.left = ((border.width / 2) + 2) * -1;

            // to adjust width so name of player can be shown in center
            // const cloneNum = createPlayerNumber(
            //     playerNumber.toString(),
            //     'rgba(0,0,0,0)',
            //     textSize
            // );
            // cloneNum.top = ((border.height / 2) + 2) * -1;
            // cloneNum.left = ((border.width / 2) + 2);

            // add border
            const avatar = new Group([border, imageCircle], {
                custom: {
                    type: 'player-avatar',
                    id: uuidv4(),
                }
            });
            
            // Create the group elements array
            const groupElements = [avatar, number];
            
            // Add player name if provided
            if (playerName) {
                const nameText = createPlayerName(playerName, sizeValue.nameTop);
                groupElements.push(nameText);
            }
            
            const player = new Group(groupElements, {
                custom: {
                    type: 'player',
                    subType: 'playerCircleImage',
                    id: uuidv4(),
                    team: colors.name,
                    size,
                    ...customData
                },
                angle: 0,
                left: posX,
                top: posY,
                originX: 'center',
                originY: 'center',
                hasBorders: false,
                hasControls: false,
            });
        
            onComplete && onComplete(canvas, player);
        });
    }
    else {
        const textSize = 28 + size;
        const number = createPlayerNumber(
            playerNumber.toString(),
            colors.textColor,
            textSize
        );
        
        console.log('[createPlayerCircle] playerName:', playerName);
        
        // Create the group elements array
        const groupElements = [circle, number];
        
        // Add player name if provided
        if (playerName) {
            const nameText = createPlayerName(playerName, sizeValue.nameTop);
            groupElements.push(nameText);
        }
    
        const player = new Group(groupElements, {
            custom: {
                type: 'player',
                subType: 'playerCircle',
                id: uuidv4(),
                team: colors.name,
                size,
                ...customData
            },
            angle: 0,
            originX: 'center',
            originY: 'center',
            left: posX,
            top: posY,
            hasBorders: false,
            hasControls: false,
        });
    
        onComplete && onComplete(canvas, player);
    }

};

PlayerCircle.propTypes = {
    canvas: PropTypes.object.isRequired,
};

export default PlayerCircle;